import { render, staticRenderFns } from "./UserMainInfo.vue?vue&type=template&id=2521a3a3&scoped=true&"
import script from "./UserMainInfo.vue?vue&type=script&lang=js&"
export * from "./UserMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserMainInfo.vue?vue&type=style&index=0&id=2521a3a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521a3a3",
  null
  
)

export default component.exports